module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-content-wrapper"
  }, [_c('div', {
    staticClass: "rt-content-main"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.hasAside) ? _c('div', {
    staticClass: "rt-content-aside"
  }, [_vm._t("aside")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f9ffbfe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/layout/rtContent.vue
// module id = 1461
// module chunks = 116